﻿import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import { DocumentationConstants } from '../../store/documentation-constants';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import GlobalDialog from '../Modal/GlobalDialog';
import VendorsTableManagementForm from './VendorsTableManagementForm';
import ContractAgenciesTableManagementForm from './ContractAgenciesTableManagementForm';
import DepartmentsTableManagementForm from './DepartmentsTableManagementForm';
import VmiGroupsManagementForm from './VmiGroupsManagementForm';

import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import { Toast } from 'devextreme-react/toast';

const tables = [
    { id: 100, name: "Contract Agencies", description: "Contract Agency list" },
    { id: 200, name: "Departments", description: "Departments" },
    { id: 400, name: "Vendors", description: "Vendor list" },
    { id: 500, name: "VMI Groups", description: "VMI Groups" },
    
]

export default function TablesManagementForm() {
    const [selectedTable, setSelectedTable] =
        useState<LookupItem>();

    const [toastVisible, setToastVisible] =
        useState<boolean>();

    const [toastMessage, setToastMessage] =
        useState<string>();

    const [toastType, setToastType] =
        useState<any>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    const title = selectedTable ? selectedTable.name : "Tables";

    return (
        <div className="pw-content">
            <div className="glassware-container">
                <div className="lq-title-bar pw-form-header">
                    <div className="lq-main-title">{`${title} Management`}</div>
                    <div className="title-bar-spacer" />
                    <div className="save-toolbar">
                        <div>
                            <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                                hint="go back" className="title-bar-button"
                                height={'2.6em'}
                                onClick={goBack} />
                        </div>
                        <div>
                            <NavLink to={`/documentation/${DocumentationConstants.GlasswareForm}`}
                                className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                                <Button className="title-bar-button pw-orange"
                                    text="" icon="help" type="normal"
                                    hint="help and documentation" />
                            </NavLink>
                        </div>
                    </div>
                </div>

                <div className="pw-comp-row pw-margin-top-05 pw-margin-bottom-1">
                    <div className="pw-form-unit pw-comp-20">
                        <div className="pw-form-unit-label">Selected Table</div>
                        <SelectBox id="assetType"
                            placeholder="na" height={'2.1em'}
                            dataSource={tables}
                            valueExpr='id' displayExpr="name"
                            onValueChanged={selectedTableValueChanged} />
                    </div>
                </div>

                {selectedTable && selectedTable.id === 100 &&
                    <div className="pw-margin-bottom-05">
                        <ContractAgenciesTableManagementForm title={title} />
                    </div>
                }                

                {selectedTable && selectedTable.id === 200 &&
                    <div className="pw-margin-bottom-05">
                        <DepartmentsTableManagementForm title={title} />
                    </div>
                }                
                
                {selectedTable && selectedTable.id === 400 &&
                    <div className="pw-margin-bottom-05">
                        <VendorsTableManagementForm title={title} />
                    </div>
                }

                {selectedTable && selectedTable.id === 500 &&
                    <div className="pw-margin-bottom-05">
                        <VmiGroupsManagementForm title={title} />
                    </div>
                }               

            </div>

            <Toast
                visible={toastVisible}
                message={toastMessage}
                type={toastType}
                onHiding={onToastHiding}
                displayTime={600} />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function selectedTableValueChanged(e: any) {
        const matchingTable = tables.find(t => t.id === e.value);

        if (matchingTable)
            setSelectedTable(matchingTable);
    }

    //show/hide

    function onToastHiding() {
        setToastVisible(false);
        setToastMessage(undefined);
        setToastType(undefined);
    }

    function showToast(message: string, toastType: string) {
        setToastMessage(message);
        setToastType(toastType);
        setToastVisible(true);
    }

    //navigation

    function goBack() {
        history.back();
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

